import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { channelSelectors } from '../../models/channels';
import withRerenderPrevent from '../../common/with-rerender-prevent';
import { Feature, getFeatureFlag } from '../../models/features/features';
import { HomeSection } from '../v2/home-section';

const ChannelContentFilters = ({
  randomize,
  channelIdFirstUniqRecommended,
  channelIdFirstUniqNewest,
  channelIdFirstUniqPopular,
  channelIdRandUniqRecommended,
  channelIdRandUniqNewest,
  channelIdRandUniqPopular,
  analyticsData,
}) => {
  const recommendedChannelId = randomize
    ? channelIdRandUniqRecommended
    : channelIdFirstUniqRecommended;
  const newestChannelId = randomize
    ? channelIdRandUniqNewest
    : channelIdFirstUniqNewest;
  const popularChannelId = randomize
    ? channelIdRandUniqPopular
    : channelIdFirstUniqPopular;

  const { t } = useTranslation();

  const analyticsDataFor = (filter) => ({
    ...analyticsData,
    location: `${analyticsData.location}_channel_${filter}`,
  });

  const newTopicsString = useSelector((state) =>
    getFeatureFlag(state, Feature.CHANNELS_TO_TOPICS_ENABLED)
  );

  const recommendedChannelString = newTopicsString
    ? 'landing.recommended_topic'
    : 'landing.recommended_channel';
  const newestChannelString = newTopicsString
    ? 'landing.newest_topic'
    : 'landing.newest_channel';
  const mostPopularChannelString = newTopicsString
    ? 'landing.most_popular_topic'
    : 'landing.most_popular_channel';

  return (
    <div className="channels-content-filters container">
      {recommendedChannelId ? (
        <HomeSection
          title={t(recommendedChannelString)}
          channelId={recommendedChannelId}
          analyticsData={analyticsDataFor('recommended')}
        />
      ) : null}

      {newestChannelId ? (
        <HomeSection
          title={t(newestChannelString)}
          channelId={newestChannelId}
          analyticsData={analyticsDataFor('newest')}
        />
      ) : null}

      {popularChannelId ? (
        <HomeSection
          title={t(mostPopularChannelString)}
          channelId={popularChannelId}
          analyticsData={analyticsDataFor('popular')}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  channelIdFirstUniqRecommended:
    channelSelectors.getChannelIdFirstUniqRecommended(state, ownProps),
  channelIdFirstUniqNewest: channelSelectors.getChannelIdFirstUniqNewest(
    state,
    ownProps
  ),
  channelIdFirstUniqPopular: channelSelectors.getChannelIdFirstUniqPopular(
    state,
    ownProps
  ),
  channelIdRandUniqRecommended:
    channelSelectors.getChannelIdRandUniqRecommended(state, ownProps),
  channelIdRandUniqNewest: channelSelectors.getChannelIdRandUniqNewest(
    state,
    ownProps
  ),
  channelIdRandUniqPopular: channelSelectors.getChannelIdRandUniqPopular(
    state,
    ownProps
  ),
});

export default compose(
  connect(mapStateToProps, null),
  withRerenderPrevent
)(ChannelContentFilters);
